/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";

interface OutputItem {
  label: string;
  value: string;
}

interface UseTransformListProps {
  inputList: any;
  labelField: string;
  valueField: string;
}

export function useTransformList({
  inputList,
  labelField,
  valueField,
}: UseTransformListProps) {
  const transformList = (): OutputItem[] => {
    return inputList?.map((item: any) => ({
      label: item[labelField],
      value: item[valueField],
    }));
  };

  return transformList();
}
// {
//   transformedList.map((item, index) => (
//     <li key={index}>
//       Label: {item.label}, Value: {item.value}
//     </li>
//   ));
// }
